import React, { useMemo, useState } from "react";
import CoinAmount from "./CoinAmount.jsx";

function compareValues(left, right, direction) {
  const multiplier = direction === "asc" ? 1 : -1;

  if (typeof left === "number" || typeof right === "number") {
    return ((Number(left) || 0) - (Number(right) || 0)) * multiplier;
  }

  return String(left || "").localeCompare(String(right || "")) * multiplier;
}

export default function ItemsTable({ items = [], onRowClick, assignmentMode = false }) {
  const [sortBy, setSortBy] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");

  const sortedItems = useMemo(() => {
    const next = items.map((item, index) => ({ item, index }));

    next.sort((leftEntry, rightEntry) => {
      const left = leftEntry.item;
      const right = rightEntry.item;

      if (sortBy === "name") {
        const primary = compareValues(left?.name, right?.name, sortDirection);
        if (primary !== 0) return primary;
      }
      if (sortBy === "buy") {
        const primary = compareValues(left?.tp_buy_price, right?.tp_buy_price, sortDirection);
        if (primary !== 0) return primary;
      }
      if (sortBy === "sell") {
        const primary = compareValues(left?.tp_sell_price, right?.tp_sell_price, sortDirection);
        if (primary !== 0) return primary;
      }

      return leftEntry.index - rightEntry.index;
    });

    return next.map((entry) => entry.item);
  }, [items, sortBy, sortDirection]);

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortDirection((previous) => (previous === "asc" ? "desc" : "asc"));
      return;
    }

    setSortBy(column);
    setSortDirection("asc");
  };

  const renderSortMarker = (column) => {
    if (sortBy !== column) return "";
    return sortDirection === "asc" ? " ▲" : " ▼";
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0, minWidth: 520 }}>
        <thead>
          <tr>
            <th style={{ textAlign: "left", padding: "10px 8px", color: "#9be7ff" }}>Icon</th>
            <th style={{ textAlign: "left", padding: "10px 8px" }}>
              <button type="button" className="names-btn secondary" onClick={() => handleSort("name")}>Name{renderSortMarker("name")}</button>
            </th>
            <th style={{ textAlign: "left", padding: "10px 8px" }}>
              <button type="button" className="names-btn secondary" onClick={() => handleSort("buy")}>Buy{renderSortMarker("buy")}</button>
            </th>
            <th style={{ textAlign: "left", padding: "10px 8px" }}>
              <button type="button" className="names-btn secondary" onClick={() => handleSort("sell")}>Sell{renderSortMarker("sell")}</button>
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedItems.map((item, index) => (
            (() => {
              const isOutOfStock = (item?.count ?? 0) <= 0;
              const rowCursor = assignmentMode
                ? (isOutOfStock ? "not-allowed" : "copy")
                : (onRowClick ? "pointer" : "default");
              const rowOpacity = isOutOfStock ? 0.45 : 1;

              return (
                <tr
                  key={`${item?.id ?? "item"}-${index}`}
                  onClick={() => onRowClick?.(item)}
                  style={{ cursor: rowCursor, opacity: rowOpacity }}
                >
              <td style={{ padding: "8px", borderTop: "1px solid rgba(144,224,239,0.2)" }}>
                <div style={{ width: 36, height: 36, borderRadius: 8, border: "1px solid rgba(144,224,239,0.35)", background: "rgba(3, 20, 44, 0.65)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {item.icon ? <img src={item.icon} alt={item.name || "item"} style={{ width: 28, height: 28, objectFit: "contain" }} /> : null}
                </div>
              </td>
              <td style={{ padding: "8px", borderTop: "1px solid rgba(144,224,239,0.2)", color: "#d8f5ff", fontWeight: 600 }}>
                {item.name || "Unknown item"}
              </td>
              <td style={{ padding: "8px", borderTop: "1px solid rgba(144,224,239,0.2)", color: "#cfeeff" }}>
                <CoinAmount value={item.tp_buy_price} compact />
              </td>
              <td style={{ padding: "8px", borderTop: "1px solid rgba(144,224,239,0.2)", color: "#cfeeff" }}>
                <CoinAmount value={item.tp_sell_price} compact />
              </td>
                </tr>
              );
            })()
          ))}
        </tbody>
      </table>
    </div>
  );
}
